(function () {
  var MS = 300;

  function slideDown(el) {
    el.style.display = 'block';
    el.style.overflow = 'hidden';
    el.style.maxHeight = '0';
    el.style.opacity = '0';
    el.offsetHeight; // force reflow
    el.style.transition = 'max-height ' + MS + 'ms ease, opacity ' + MS + 'ms ease';
    el.style.maxHeight = el.scrollHeight + 'px';
    el.style.opacity = '1';
    setTimeout(function () {
      el.style.transition = '';
      el.style.overflow = '';
      el.style.maxHeight = '';
      el.style.opacity = '';
    }, MS);
  }

  function slideUp(el) {
    el.style.overflow = 'hidden';
    el.style.maxHeight = el.scrollHeight + 'px';
    el.offsetHeight; // force reflow
    el.style.transition = 'max-height ' + MS + 'ms ease, opacity ' + MS + 'ms ease';
    el.style.maxHeight = '0';
    el.style.opacity = '0';
    setTimeout(function () {
      el.style.transition = '';
      el.style.overflow = '';
      el.style.maxHeight = '';
      el.style.opacity = '';
      el.style.display = 'none';
    }, MS);
  }

  function getDesc(title) {
    var el = title.nextElementSibling;
    return el && el.classList.contains('product-about__accordion-description') ? el : null;
  }

  function initProductAccordion() {
    document.querySelectorAll('.product-about__accordion-title').forEach(function (title) {
      title.addEventListener('click', function () {
        var isActive = title.classList.contains('active');
        // Close all open
        document.querySelectorAll('.product-about__accordion-title.active').forEach(function (t) {
          t.classList.remove('active');
          var d = getDesc(t);
          if (d) slideUp(d);
        });
        // Open if it was closed
        if (!isActive) {
          title.classList.add('active');
          var d = getDesc(title);
          if (d) slideDown(d);
        }
      });
    });
  }

  document.addEventListener('shopify:section:load', initProductAccordion);
  initProductAccordion();
})();
